import React, { Component } from 'react';
import Link from 'gatsby-link';
import { Icon } from 'semantic-ui-react';
import snackbarData from '../../data/snackbar'
import './snackbar.scss';

class Snackbar extends Component {
  constructor() {
    super();
    this.state = { show: snackbarData.isShown };

    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    // if they do not want the annoucemnt to show
    this.setState({ show: false });
  }

  render() {
    const { show } = this.state;
    const { enabled } = this.props;
    const display = show && enabled ? 'block' : 'none';
    return (<div className="snackbar" style={{ display }}>
      <div className="snackbar__content" dangerouslySetInnerHTML={{__html: snackbarData.content}}/>
      <div className="snackbar__close" onClick={() => this.handleClose()}>
        <Icon name="close" />
      </div>
            </div>);
  }
}

export default Snackbar;



// WEBPACK FOOTER //
// ./src/components/snackbar/index.js